(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPlan", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learningPlan/learningPlanView.html",
            controller: ["authService", "frameworkService", "learningPlanResource", "learningPlanService", "$rootScope", "$scope", "$state", "$sessionStorage", "_", LearningPlanCtrl],
            controllerAs: "vm"
        };
        function LearningPlanCtrl(authService, frameworkService, learningPlanResource, learningPlanService, $rootScope, $scope, $state, $sessionStorage, _) {
            var vm = this;
            //vm.categories = [];
            //vm.filteredCategories = [];
            vm.search = "";
            vm.view = "tile";
            vm.frameworkData = frameworkService.data;
            vm.storefrontEnabled = frameworkService.data.tenantFeatures.storefront;
            vm.hasInventory = authService.authentication.hasInventory;
            vm.filterPaths = filterPaths;
            vm.changeView = changeView;
            vm.getBands = getBands;
            vm.getPaths = getPaths;
            if ($sessionStorage.learningPlanView) {
                vm.view = $sessionStorage.learningPlanView;
            }
            learningPlanService.getData().then(function () {
                loadData();
            });
            //if (frameworkService.data.tenantFeatures.gamification) {
            //	learningPlanResource.getGamificationSummary().$promise
            //		.then((data) => vm.gamificationSummary = data, () => false);
            //}
            //////////////////////////////////////////////
            function loadData() {
                vm.data = learningPlanService.data;
                vm.categories = vm.data.categories;
                vm.bands = vm.data.bands;
                vm.learningPaths = _.filter(vm.data.learningPaths, function (path) {
                    return path.bandId !== null;
                });
                vm.uncategorizedPaths = _.filter(vm.data.learningPaths, function (path) {
                    return path.bandId === null;
                });
                vm.filteredCategories = angular.copy(vm.categories);
                vm.filteredBands = angular.copy(vm.bands);
                vm.filteredPaths = angular.copy(vm.learningPaths);
                vm.filteredUncategorizedPaths = angular.copy(vm.uncategorizedPaths);
                if ($sessionStorage.learningPlanSearch) {
                    vm.search = $sessionStorage.learningPlanSearch;
                    vm.filterPaths();
                }
            }
            function getBands(categoryId) {
                return _.filter(vm.filteredBands, function (band) {
                    return band.categoryId === categoryId;
                });
            }
            function getPaths(bandId) {
                return _.filter(vm.filteredPaths, function (path) {
                    return path.bandId === bandId;
                });
            }
            $scope.$on("learningPlanRefreshed", function () {
                loadData();
                if (frameworkService.data.tenantFeatures.gamification)
                    learningPlanResource.getGamificationSummary().$promise
                        .then(function (data) { return vm.gamificationSummary = data; }, function () { return false; });
            });
            vm.toggleQuickLinks = function () {
                $rootScope.$broadcast("toggleQuickLinks");
            };
            vm.openPath = function (path) {
                $state.go("main.learningPath", { number: path.number, version: path.version });
            };
            //var removeOnRefreshLearningPlan;
            //function registerOnRefreshLearningPlan() {
            //	removeOnRefreshLearningPlan = userHubService.onRefreshLearningPlan(function () {
            //		learningPlanService.refresh();
            //	});
            //}
            //registerOnRefreshLearningPlan();
            function changeView(view) {
                vm.view = view;
                $sessionStorage.learningPlanView = view;
            }
            function filterPaths() {
                $sessionStorage.learningPlanSearch = vm.search;
                vm.filteredCategories = angular.copy(vm.categories);
                vm.filteredBands = angular.copy(vm.bands);
                vm.filteredPaths = angular.copy(vm.learningPaths);
                vm.filteredUncategorizedPaths = angular.copy(vm.uncategorizedPaths);
                if (vm.search.length !== 0) {
                    vm.filteredPaths = _.filter(vm.filteredPaths, function (path) {
                        return path.name.toLowerCase().indexOf(vm.search.toLowerCase()) > -1;
                    });
                    vm.filteredBands = _.filter(vm.filteredBands, function (band) {
                        return _.some(vm.filteredPaths, { bandId: band.bandId });
                    });
                    vm.filteredCategories = _.filter(vm.filteredCategories, function (category) {
                        return _.some(vm.filteredBands, { categoryId: category.categoryId });
                    });
                    vm.filteredUncategorizedPaths = _.filter(vm.filteredUncategorizedPaths, function (path) {
                        return path.name.toLowerCase().indexOf(vm.search.toLowerCase()) > -1;
                    });
                }
            }
        }
    });
}());
